import { ComponentType } from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import LoadingSpinner from "@/presentation/ui/components/common/LoadingSpinner";
import { AuthProvider } from "@/providers/auth";
import { FeedbackProvider } from "@/infrastructure/services/feedback";
const onRedirectingLoader = () => {
  return <LoadingSpinner />;
};

const withAuthGuard = (component: ComponentType<object>) => {
  const Component = withAuthenticationRequired(component, {
    loginOptions: {
      authorizationParams: {
        screen_hint: "login",
      },
    },
    returnTo: globalThis.location.pathname,
    onRedirecting: () => onRedirectingLoader(),
  });

  return Component;
};

import React from "react";

export const AuthenticationGuard: React.FC<{
  component: ComponentType<object>;
}> = ({ component }) => {
  const Component = React.useMemo(() => withAuthGuard(component), [component]);

  return (
    <AuthProvider>
      <FeedbackProvider>
        <Component />
      </FeedbackProvider>
    </AuthProvider>
  );
};
